const PaymentType = {
  PAYMENT_SMS: 1,
  PAYMENT_IAP_IOS: 2,
  PAYMENT_GATE: 3,
  PAYMENT_IAP_ANDROID: 4
}
export default PaymentType
